const DOESNT_MATTER_ANSWERS = new Set([
  'not-looking-for-specific-support',
  'not looking for specific support',
  "doesn't matter",
  'doesnt matter',
  'doesnt-matter',
  'please select',
]);

function normalizeAnswer(value: string): string {
  return value.trim().toLowerCase().replace(/[’‘]/g, "'");
}

/**
 * A blank answer and "Doesn't matter" (including the older
 * "Not looking for specific support" reply) are hidden from investors.
 */
export function formatInvestorExpertise(
  expertise?: string | null,
  otherExpertise?: string | null
): string | null {
  const raw = typeof expertise === 'string' ? expertise.trim() : '';
  if (!raw || DOESNT_MATTER_ANSWERS.has(normalizeAnswer(raw))) {
    return null;
  }

  const key = normalizeAnswer(raw);
  if (key === 'expertise-in-industry') return 'Expertise in the industry';
  if (key === 'contacts-in-industry') return 'Contacts in the industry';
  if (key === 'looking-for-other-support') {
    const other = typeof otherExpertise === 'string' ? otherExpertise.trim() : '';
    return other || 'Other support';
  }

  return raw;
}
